
 


  


<div class="client-container">
  <div class="title-wrapper">
    <h1>Welcome to Client Management!</h1>
  </div>

  <app-table-controls (event)="handleEvents($event)"></app-table-controls>

  <!-- Loading Spinner -->
  <div class="loading-container" *ngIf="isLoadingClients">
    <div class="spinner"></div>
    <p class="loading-text">Loading clients...</p>
  </div>

  <!-- Client List Content -->
  <div class="ess-mss-notifications-content" *ngIf="!isLoadingClients">
      <!-- Empty State Message -->
      <div class="empty-state-container" *ngIf="paginatedCompanies.length === 0">
        <mat-icon class="empty-state-icon">inbox</mat-icon>
        <h3 class="empty-state-title">No clients found</h3>
        <p class="empty-state-message" *ngIf="searchTerm()">
          No clients match your search criteria. Try adjusting your search terms.
        </p>
        <p class="empty-state-message" *ngIf="!searchTerm()">
          There are currently no clients to display. Click "New Client" to add your first client.
        </p>
      </div>

      <!-- Client List -->
      <ng-container
        *ngFor="let n of paginatedCompanies"
      >
        <div class="ess-mss-notifications-row" (click)="onRowClick(n)">
          <div class="ess-mss-notifications-col">
              <!-- <span class="line1">Client Name</span> -->
            <span class="line1">{{ n.ClientName }}</span>
              <span class="line2">{{ n.Branch }}</span>
            
          </div>
           <div class="ess-mss-notifications-col ess-col-two">
            <span class="line2">Company Code</span>
            <span class="line2">{{ n.companyRegNo }}</span>
          </div>
        <div class="ess-mss-notifications-col ess-col-two">
            <span class="line2">Fin Number</span>
            <span class="line2">{{ n.CMSFinNumber }}</span>
          </div>
          <div class="ess-mss-notifications-col ess-col-two">
            <!-- <span class="line1">Registration Date</span> -->
                 <span class="line2">{{'Created '}}</span>
            <span class="line2">{{ n.Registration }}</span>
          </div>
         <div class="ess-mss-notifications-col ess-col-two">
            <!-- <span class="line1">Employee Headcoun Limit</span> -->
          <span class="line2">{{'License Limit '}}</span>
            <span class="line2">{{ n.EmployeeHeadcountLimit}}</span>
          </div>
          <!-- <div class="ess-mss-notifications-col ess-col-two">
            <span class="line1">Branch</span> 
            <span class="line2">{{ n.Branch }}</span>
          </div> -->

          
          <!-- Action Column -->
   <div class="ess-mss-notifications-col ess-status-col">
  <span class="line2">Status</span>
  <span class="line1" [ngClass]="getStatusClass(n.status)" [style.color]="getStatusColor(n)">
    {{ n.status }}
  </span>
  <span class="line2 expiry-warning" *ngIf="shouldShowExpiryWarning(n)" [style.color]="'#000000'" [style.font-weight]="'700'">
    {{ getFormattedExpiryDate(n) }}
  </span>
</div>
    <div class="ess-mss-notifications-col ess-status-col">
            <span class="line2">Action</span>
          <div class="attachment-icon-container">
            <!-- <a (click)="goToBilling(n)" class="ess-mss-notifications-attachment-link" title="Maintenance">
              <mat-icon>settings</mat-icon>
            </a> -->
            <a (click)="openUpdateClientDialog(n.id || n.clientId || '')" class="ess-mss-notifications-attachment-link" title="Update">
              <mat-icon style="color: #3fb498;">edit</mat-icon>
            </a>
            <a *ngIf="n.status !== 'Suspended'" (click)="openLicenseExpiryDialog(n.id || n.clientId || '')" class="ess-mss-notifications-attachment-link" title="Suspend">
              <mat-icon style="color: #f97316;">pause_circle_outline</mat-icon>
            </a>
            <a *ngIf="n.status === 'Suspended'" (click)="openReactivateDialog(n.id || n.clientId || '')" class="ess-mss-notifications-attachment-link" title="Reactivate">
              <mat-icon style="color: #22c55e;">play_circle_outline</mat-icon>
            </a>
          </div>
        </div>
        </div>
      </ng-container>
    </div>

    <!-- Pagination Controls -->
    <div class="pagination-container" *ngIf="!isLoadingClients && totalPages > 1">
      <div class="pagination-info">
        Showing {{ (currentPage - 1) * pageSize + 1 }} to {{ Math.min(currentPage * pageSize, totalItems) }} of {{ totalItems }} {{ searchTerm() ? 'matches' : 'records' }}
      </div>
      <div class="pagination-controls">
        <button
          class="pagination-btn"
          (click)="goToFirstPage()"
          [disabled]="currentPage === 1"
          title="First Page">
          <mat-icon>first_page</mat-icon>
        </button>
        <button
          class="pagination-btn"
          (click)="goToPreviousPage()"
          [disabled]="currentPage === 1"
          title="Previous Page">
          <mat-icon>chevron_left</mat-icon>
        </button>

        <div class="pagination-numbers">
          <button
            *ngFor="let page of getPageNumbers()"
            class="pagination-number-btn"
            [class.active]="page === currentPage"
            (click)="goToPage(page)">
            {{ page }}
          </button>
        </div>

        <button
          class="pagination-btn"
          (click)="goToNextPage()"
          [disabled]="currentPage === totalPages"
          title="Next Page">
          <mat-icon>chevron_right</mat-icon>
        </button>
        <button
          class="pagination-btn"
          (click)="goToLastPage()"
          [disabled]="currentPage === totalPages"
          title="Last Page">
          <mat-icon>last_page</mat-icon>
        </button>
      </div>
    </div>
</div>


